<template>
  <div class="change-password-wrapper">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="change-password-container">
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.oldPassword.label')"
          v-model="old_password"
          :validate-rules="'password'"
          :name="'password'"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.newPassword.label')"
          v-model="new_password"
          :validate-rules="'password'"
          :name="'password'"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.confirmPassword.label')"
          v-model="confirmPassword"
          :name="'passwordConfirmation'"
          :validate-rules="`passwordConfirmation:${this.new_password}`"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-otp-input
          v-model="otp"
          @getOtpCode="getOtpCode()"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="btns-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.changePasswordPage.btnSave')"
            class="save-btn"
            :disabled="isSaveBtnDisabled"
            :is-loading="isSaveBtnLoading"
            @click="changePassword()"
          />
        </div>

        <div class="btn-container">
          <base-button
            :text="$t('message.changePasswordPage.btnCancel')"
            class="cancel-btn"
            @click="$router.push({name: 'settings'})"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePasswordInput from '../../components/base/BasePasswordInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseOtpInput from '../../components/base/BaseOtpInput.vue';

export default {
  name: 'ChangePassword',
  inject: ['$httpService'],
  components: {
    BasePasswordInput,
    BaseButton,
    BaseOtpInput
  },
  data() {
    return {
      old_password: '',
      new_password: '',
      confirmPassword: '',
      otp: '',
      message_id: '',
      isSaveBtnLoading: false
    }
  },
  methods: {
    async getOtpCode() {
        try {
          const response = await this.$httpService.auth.getAuthorizedOtpCode();

          this.message_id = response.data.message_id;
          this.$toast({text: this.$t('message.signIn.otpToastMsg')});
        } catch (error) {
          this.$router.push({name: 'settings'});
        }
    },
    async changePassword() {
      this.isSaveBtnLoading = true;

      const payload = {
        old_password: this.old_password,
        new_password: this.new_password,
        otp: +this.otp
      }

      try {
        const response = await this.$httpService.msi.changePassword(payload);

        if (response.data) {
          this.$toast({text: this.$t('message.changePasswordPage.toastMsg')});
          this.isSaveBtnLoading = false;
          this.$router.push({name: 'settings'});
        }
      } catch (error) {
        this.isSaveBtnLoading = false;
      }
    }
  },
  computed: {
    isSaveBtnDisabled() {
      return this.isFieldsEmpty || this.isHasErrors;
    },
    isFieldsEmpty() {
      return !this.old_password || !this.new_password || !this.confirmPassword || !this.otp;
    },
    isHasErrors() {
      return this.errors.items.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .change-password-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }

  .change-password-container {
    @include base-page-container;
    flex-direction: column;
  }

  .password-container {
    width: 343px;
  }

  .btns-block {
    display: flex;
    margin-top: 30px;
    margin-bottom: 50px;
  }

  .btn-container {
    width: 200px;
    height: 50px;
  }

  .cancel-btn {
    margin-left: 20px;
  }

  .cancel-btn ::v-deep {
      background-color: white;
      color: #41BF7B;
      border: 2px solid #41BF7B;
      transition: all 0.2s ease;

      &:hover {
        transform: scale(1.01);
      }
  }

  .save-btn ::v-deep {
    border: 2px solid #41BF7B;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.01);
    }
  }

  .save-btn ::v-deep.disabled {
    border: 2px solid rgba(64, 191, 123, 0.1);
  }

  .route-name {
    @include route-name;
    width: 95%;
    text-align: start;
    margin-bottom: 35px;
    margin-top: -20px;
  }

  @media screen and (max-width: 510px) {
    .password-container {
      width: 100%;
    }

    .btns-block {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .btn-container {
      width: 70%;
    }

    .btn-container:first-of-type {
      margin-bottom: 20px;
    }

    .cancel-btn {
      margin-left: 0;
    } 
  }
</style>